import { RetunOrderSelectModel, ReturnOrderParams, getReturnOrders } from "@NA/Services/ADIReturnSelectService";
import { getBannerCarousel } from "@NA/Services/GetBannerCarousel";
import { getVisualCarousal, visualCarousalParams, VisualFilterCarousal } from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<ReturnOrderParams, RetunOrderSelectModel>;

export const DispatchLoadReturnSelectedOrders: HandlerType = props => {
    props.dispatch({
        type: "Custom/loadReturnSelectedOrders", // This type is being used by P21
        // type: "Custom/LoadSelectedOrder", Code from Spire Prod
        result: props.parameter,
    });
};

export const loadReturnSelectedOrdersResult: HandlerType = async props => {
    props.apiResult = await getReturnOrders(props.parameter);
};

export const DispatchCompleteLoadReturnSelectedOrders: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteVisualFilters", // This type is being used in P21.
        // type: "Custom/DispatchCompleteSelectedOrder" // Code from Spire Prod
        rmaSelectedOrder: props.apiResult,
    });
};

export const chain = [
    DispatchLoadReturnSelectedOrders,
    loadReturnSelectedOrdersResult,
    DispatchCompleteLoadReturnSelectedOrders,
];

const loadReturnSelectedOrders = createHandlerChainRunner(chain, "loadReturnSelectedOrders");
export default loadReturnSelectedOrders;
